import React from "react";
import GlobalLibrary from "../Articles/GlobalLibrary/GlobalLibrary";
import "./MasterDataArticles.css";

const MasterDataGlobalLibrary = () => {
  return (
    <div className="data-config-container">
      <h2>Global Library</h2>

      <GlobalLibrary />
    </div>
  );
};

export default MasterDataGlobalLibrary;